import { IActionFn } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import { getStorage } from '@/utils/storage';
import store from '@/store';

// 查询角色列表
export const queryRoleList: IActionFn<IModuleState> = async ({ commit, state }, orgId) => {
  try {
    commit('setRoleList', { ...state.roleList, loading: true });
    const res = await $http.post('/v1/baseinfo/role/list', { orgId });
    commit('setRoleList', { data: res });
  } catch (e) {
    commit('setRoleList', { data: [] });
  }
};

// 查询当前登录用户所在组织拥有的权限列表
export const queryAclsByMine: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    const orgId = JSON.parse(getStorage('userInfo') || '{}').orgId;
    commit('setMineAcls', { ...state.mineAcls, loading: true });
    const res = await $http.post('/v1/baseinfo/priv/list', { orgId });
    commit('setMineAcls', { data: res });
  } catch (e) {
    commit('setMineAcls', { data: [] });
  }
};

// 查询组织的权限列表
export const queryAclsByOrg: IActionFn<IModuleState> = async ({ commit, state }, orgId) => {
  try {
    commit('setOrgAcls', { ...state.orgAcls, loading: true });
    const res = await $http.post('/v1/baseinfo/priv/list', { orgId });
    commit('setOrgAcls', { data: res });
  } catch (e) {
    commit('setOrgAcls', { data: [] });
  }
};

// 查询角色的权限列表
export const queryAclsByRole: IActionFn<IModuleState> = async ({ commit, state }, roleId) => {
  try {
    commit('setRoleAcls', { ...state.roleAcls, loading: true });
    const res = await $http.post('/v1/baseinfo/role/privlist', { roleId });
    commit('setRoleAcls', { data: res });
  } catch (e) {
    commit('setRoleAcls', { data: [] });
  }
};

// 添加角色
export const addRole: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/baseinfo/role/add', payload);
    store.commit('common/setToast', { visible: true, text: '角色添加成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 编辑角色
export const editRole: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/baseinfo/role/modify', payload);
    store.commit('common/setToast', { visible: true, text: '保存成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 删除角色
export const deleteRole: IActionFn<IModuleState> = async ({ commit, state }, roleId) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/baseinfo/role/delete', { roleId });
  } finally {
    commit('setConfirm', { visible: false, loading: false });
  }
};
